import { getNextjsApiBaseUrl } from '@/config/apiBaseUrl'
import { clearImpersonationStorage } from '@/lib/auth/impersonation'
import { useAuthStore } from '@/store/useAuthStore'

export const AUTH_STORE_PERSIST_KEY = 'auth-store'

export function clearAuthPersistedStorage(): void {
  try {
    localStorage.removeItem(AUTH_STORE_PERSIST_KEY)
  } catch (error) {
    console.warn('[clearStaleAuthState] could not clear auth storage', error)
  }
}

interface ClearStaleAuthStateOptions {
  /** POST /auth/logout pour effacer les cookies HttpOnly (défaut: true). */
  callLogoutApi?: boolean
}

/**
 * Nettoie l'état auth client corrompu (store, localStorage, cookies via API).
 * À appeler après un échec OAuth, login ou callback — pas à chaque visite anonyme.
 */
export async function clearStaleAuthState(
  options: ClearStaleAuthStateOptions = {}
): Promise<void> {
  const callLogoutApi = options.callLogoutApi ?? true

  clearImpersonationStorage()

  try {
    await useAuthStore.getState().clearAuth()
  } catch (error) {
    console.warn('[clearStaleAuthState] clearAuth failed', error)
  }

  clearAuthPersistedStorage()

  if (!callLogoutApi) {
    return
  }

  try {
    await fetch(`${getNextjsApiBaseUrl()}/api/app/v1/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    })
  } catch (error) {
    console.warn('[clearStaleAuthState] logout API failed', error)
  }
}
